<i18n>
{
  "ru": {
    "malls": "Торговые центры",
    "markets": "Рынки",
    "shops": "Магазины"
  },
  "uk": {
    "malls": "Торгові центри",
    "markets": "Ринки",
    "shops": "Магазини"
  }
}
</i18n>

<template>
  <div class="col-md-12" v-if="$store.state.GlobalData.places">
    <b-tabs class="as-nav-tabs">
      <b-tab :title="$t('malls')" active>
        <div class="row">
          <div class="col-md-6">
            <div class="tab-block flex">
              <div class="img-block col-md-5">
                <img
                  src="//[[.StaticDomain]]/assets/portal/images/mall_1.jpg"
                />
              </div>
              <div class="desc-block col-md-7">
                <div class="name-block">
                  <a href="#">Название Название Название Название</a>
                </div>
                <ul>
                  <li><span>Адрес:</span> ул. Владимирская 1</li>
                  <li><span>Город:</span> Васильков</li>
                  <li><span>Режим работы:</span> с 09:00 до 21:00</li>
                </ul>
                <div class="footer-block">
                  <button class="btn btn-link as-btn-link">Подробнее</button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="tab-block flex">
              <div class="img-block col-md-5">
                <img
                  src="//[[.StaticDomain]]/assets/portal/images/mall_1.jpg"
                />
              </div>
              <div class="desc-block col-md-7">
                <div class="name-block">
                  <a href="#">Название</a>
                </div>
                <ul>
                  <li><span>Адрес:</span> ул. Владимирская 1</li>
                  <li><span>Город:</span> Васильков</li>
                  <li><span>Режим работы:</span> с 09:00 до 21:00</li>
                </ul>
                <div class="footer-block">
                  <button class="btn btn-link as-btn-link">Подробнее</button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="tab-block flex">
              <div class="img-block col-md-5">
                <img
                  src="//[[.StaticDomain]]/assets/portal/images/mall_1.jpg"
                />
              </div>
              <div class="desc-block col-md-7">
                <div class="name-block">
                  <a href="#">Название</a>
                </div>
                <ul>
                  <li><span>Адрес:</span> ул. Владимирская 1</li>
                  <li><span>Город:</span> Васильков</li>
                  <li><span>Режим работы:</span> с 09:00 до 21:00</li>
                </ul>
                <div class="footer-block">
                  <button class="btn btn-link as-btn-link">Подробнее</button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="tab-block flex">
              <div class="img-block col-md-5">
                <img
                  src="//[[.StaticDomain]]/assets/portal/images/mall_1.jpg"
                />
              </div>
              <div class="desc-block col-md-7">
                <div class="name-block">
                  <a href="#">Название</a>
                </div>
                <ul>
                  <li><span>Адрес:</span> ул. Владимирская 1</li>
                  <li><span>Город:</span> Васильков</li>
                  <li><span>Режим работы:</span> с 09:00 до 21:00</li>
                </ul>
                <div class="footer-block">
                  <button class="btn btn-link as-btn-link">Подробнее</button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="tab-block flex">
              <div class="img-block col-md-5">
                <img
                  src="//[[.StaticDomain]]/assets/portal/images/mall_1.jpg"
                />
              </div>
              <div class="desc-block col-md-7">
                <div class="name-block">
                  <a href="#">Название</a>
                </div>
                <ul>
                  <li><span>Адрес:</span> ул. Владимирская 1</li>
                  <li><span>Город:</span> Васильков</li>
                  <li><span>Режим работы:</span> с 09:00 до 21:00</li>
                </ul>
                <div class="footer-block">
                  <button class="btn btn-link as-btn-link">Подробнее</button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="tab-block flex">
              <div class="img-block col-md-5">
                <img
                  src="//[[.StaticDomain]]/assets/portal/images/mall_1.jpg"
                />
              </div>
              <div class="desc-block col-md-7">
                <div class="name-block">
                  <a href="#">Название</a>
                </div>
                <ul>
                  <li><span>Адрес:</span> ул. Владимирская 1</li>
                  <li><span>Город:</span> Васильков</li>
                  <li><span>Режим работы:</span> с 09:00 до 21:00</li>
                </ul>
                <div class="footer-block">
                  <button class="btn btn-link as-btn-link">Подробнее</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-tab>
      <b-tab :title="$t('markets')">
        <div class="row">
          <div class="col-md-6">
            <div class="tab-block flex">
              <div class="img-block col-md-5">
                <img
                  src="//[[.StaticDomain]]/assets/portal/images/mall_1.jpg"
                />
              </div>
              <div class="desc-block col-md-7">
                <div class="name-block">
                  <a href="#">Название</a>
                </div>
                <ul>
                  <li><span>Адрес:</span> ул. Владимирская 1</li>
                  <li><span>Город:</span> Васильков</li>
                  <li><span>Режим работы:</span> с 09:00 до 21:00</li>
                </ul>
                <div class="footer-block">
                  <button class="btn btn-link as-btn-link">Подробнее</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-tab>
      <b-tab :title="$t('shops')">
        <div class="row">
          <div class="col-md-6">
            <div class="tab-block flex">
              <div class="img-block col-md-5">
                <img
                  src="//[[.StaticDomain]]/assets/portal/images/mall_1.jpg"
                />
              </div>
              <div class="desc-block col-md-7">
                <div class="name-block">
                  <a href="#">Название</a>
                </div>
                <ul>
                  <li><span>Адрес:</span> ул. Владимирская 1</li>
                  <li><span>Город:</span> Васильков</li>
                  <li><span>Режим работы:</span> с 09:00 до 21:00</li>
                </ul>
                <div class="footer-block">
                  <button class="btn btn-link as-btn-link">Подробнее</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
export default {};
</script>
